export const VERIFY_MANUAL_TRANSACTION = {
    SUCCESS: "VERIFY_MANUAL_TRANSACTION_SUCCESS",
    LOADING: 'VERIFY_MANUAL_TRANSACTION_LOADING',
    ERROR: "VERIFY_MANUAL_TRANSACTION_ERROR"
}

export const QR_INIT_MANUAL = {
    SUCCESS: "QR_INIT_MANUAL_SUCCESS",
    LOADING: 'QR_INIT_MANUAL_LOADING',
    ERROR: "QR_INIT_MANUAL_ERROR"
}

export const QR_MANUAL_CHECK = {
    SUCCESS: "QR_MANUAL_CHECK_SUCCESS",
    LOADING: 'QR_MANUAL_CHECK_LOADING',
    ERROR: "QR_MANUAL_CHECK_ERROR"
}